"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeObjects = exports.mapObject = exports.filterObject = exports.getObjectKeys = exports.getObjectEntries = void 0;
/** Object.entries */
const getObjectEntries = (object, filter = (_) => true) => {
    const entries = Object.entries(object);
    const result = entries.filter(filter);
    return result;
};
exports.getObjectEntries = getObjectEntries;
/** Object.keys */
const getObjectKeys = (object, filter) => {
    const entries = (0, exports.getObjectEntries)(object, filter);
    const result = entries.map(([key]) => key);
    return result;
};
exports.getObjectKeys = getObjectKeys;
const filterObject = (object, filter) => {
    const entries = (0, exports.getObjectEntries)(object, filter);
    const result = entries.reduce((acc, [key, value]) => ({
        ...acc,
        [key]: value,
    }), {});
    return result;
};
exports.filterObject = filterObject;
const mapObject = (object, map) => {
    const entries = (0, exports.getObjectEntries)(object);
    const result = entries.reduce((acc, [key, value]) => ({
        ...acc,
        [key]: map([key, value]),
    }), {});
    return result;
};
exports.mapObject = mapObject;
const mergeObjects = (obj1, obj2, merge) => {
    if (!obj1)
        return obj2;
    if (!obj2)
        return obj1;
    const keys = (0, exports.getObjectKeys)({
        ...obj1,
        ...obj2,
    });
    return keys.reduce((acc, key) => ({
        ...acc,
        [key]: merge === null || merge === void 0 ? void 0 : merge(key, obj1[key], obj2[key]),
    }), {});
};
exports.mergeObjects = mergeObjects;
//# sourceMappingURL=object.js.map